export const addAvailabilityStyles = {
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
  formBox: {
    display: "flex",
    flexDirection: "column",
    padding: "1rem",

    maxWidth: {
      xs: "90vw", // small
      sm: "60vw", // tab
      md: "40vw", // large
    },
    marginRight: "auto",
    marginLeft: "auto",
  },
  mainHeading: { fontSize: 17, fontWeight: "600" },
  mainHeadingV2: { fontSize: 17, fontWeight: "600", marginTop: "15px" },
  textField: { width: "100%" },
  lightDescription: {
    fontSize: 13,
    fontWeight: "400",
    color: "#595959",
    lineHeight: "15px",
    marginY: "5px",
  },
  radioButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  radioButtonText: {
    fontSize: "17px",
    fontFamily: "400",
    marginLeft: "10px",
  },
  mediumHeading: { fontSize: "20px", paddingY: "18px", fontWeight: "600" },
  daysRepeatingContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    marginTop: "4px",
    gap: "5px",
  },
  checkBoxContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    minWidth: "unset",
  },
  repeatDayText: {
    fontSize: "14px",
    fontFamily: "400",
    color: "#000",
    marginTop: "4px",
    marginLeft: "4px",
  },
  unCheckDays: {
    fontSize: "14px",
    fontFamily: "300",
    color: "#595959",
  },
  timeDuraionBox: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
  },
  startTimeButon: {
    border: "1px solid black",
    borderRadius: "8px",
    paddingTop: "15px",
    paddingBottom: "15px",
    paddingLeft: "10px",
    paddingRight: "10px",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  startTimeText: { fontSize: "16px", fontWeight: 400 },
  timeContainer: {
    height: "250px",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "6px", // Makes the scrollbar thinner
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#888", // Scrollbar color
      borderRadius: "10px", // Makes it rounded
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#555", // Darker shade on hover
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#f1f1f1", // Track color
    },
  },
  timeButtonContainer: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    mt: 3,
  },
  durationContainer: {
    minWidth: "60px",
    backgroundColor: "white",
    borderRadius: "8px",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid black",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "1px solid black",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "1px solid black",
    },
    ".css-11bgdin-MuiSelect-icon": {
      top: "unset",
    },
  },
  endingTimeBox: {
    display: "flex",
    alignItems: "center",
    marginTop: "8px",
  },
  endingAtText: {
    fontSize: "17px",
    fontWeight: 400,
    color: "#595959",
  },
  removeButton: {
    marginTop: "20px",
    display: "flex",
    alignItems: "center",
  },
  removeButtonText: {
    fontSize: "17px",
    fontWeight: 600,
    color: "#D7221D",
    textDecoration: "underline",
    marginLeft: "8px",
  },
  horizontalLine: {
    borderBottom: "1px solid black",
    marginTop: "10px",
  },
  anotherTimeText: {
    color: "#328734",
    fontSize: "17px",
    fontFamily: "600",
    textDecorationLine: "underline",
    cursor: "pointer",
  },
  greenButton: { width: "100%", marginTop: "20px", paddingY: "10px" },
  reviewHeadingText: {
    fontSize: "22px",
    fontFamily: "700",
    marginTop: "20px",
    marginBottom: "5px",
  },
  reviewSubHeadingText: {
    fontSize: "17px",
    fontFamily: "400",
  },
  pointerContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: "18px",
  },
  pointerBox: {
    width: "5px",
    height: "5px",
    borderRadius: "50px",
    backgroundColor: "#000",
    marginRight: "12px",
    marginBottom: "4px",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    mt: 4,
  },
  editButton: {
    width: "100%",
    borderRadius: 2,
    borderColor: "#000",
    color: "#000",
    fontWeight: "600",
    mb: 2,
  },
  publishContainer: {
    width: "100%",
    borderRadius: 2,
    backgroundColor: "#328734",
    color: "#FFF",
    fontWeight: "600",
  },
  mt10: { marginTop: "10px" },
  endingTimeImageContainer: { marginRight: "8px" },
  halfBox: { width: "48%" },
  setTimeText: { textAlign: "center", mb: 2 },
  durationFormSelect: { width: "100%" },

  // connect referee styles
  AddRefereeText: {
    fontSize: "22px",
    fontWeight: "600",
    color: "#000",
    marginTop: "12px",
  },
  AddRefereeAlertText: {
    fontWeight: "400",
    color: "#000",
    fontSize: "15px",
    lineHeight: "22.5px",
  },
  card: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#fff",
    paddingY: "6px",
    marginBottom: "8px",
  },
  imageContainer: {
    marginRight: "16px",
  },
  image: {
    width: "80px",
    height: "80px",
    borderRadius: "8px",
  },
  detailsContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "0.5px solid #8D8D8D",
  },
  textContainer: {
    flex: 1,
    paddingVertical: "10px",
  },
  name: {
    fontWeight: "600",
    fontSize: "17px",
    color: "#0D0D0D",
    lineHeight: "25.5px",
    letterSpacing: 0.347,
    marginBottom: "3px",
  },
  company: {
    fontSize: "15px",
    color: "#000",
    marginBottom: "1px",
    fontWeight: "400",
  },
  location: {
    fontSize: "15px",
    color: "#000",
    fontWeight: "400",
  },
  noInfluencerText: {
    fontSize: 17,
    color: "#000",
    textAlign: "center",
    marginTop: 10,
    fontWeight: "600",
  },
  plusIconButton: {
    backgroundColor: "#D9D9D9",
    height: "32px",
    width: "44px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "30px",
    cursor: "pointer",
  },
  SignInOuter: {
    marginTop: "20px",
    width: "100%",
  },
};
